import { createRoot } from 'react-dom/client';
import { MobileContextProvider } from './context/MobileContext';
import App from './App';

const root = createRoot(document.getElementById('root'));

root.render(
  <MobileContextProvider>
    <App />
  </MobileContextProvider>
);
